// extracted by mini-css-extract-plugin
export default {"PopupContainer":"SurveyPopUp_PopupContainer__JNGk5","QuestionText":"SurveyPopUp_QuestionText__Ebvn8","ButtonContainer":"SurveyPopUp_ButtonContainer__wt86f"};